// extracted by mini-css-extract-plugin
module.exports = {"saveWarning":"ActivityDigitalSigningConstructor_saveWarning__3bH8_","spacing":"ActivityDigitalSigningConstructor_spacing__1nj7l"};